import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
  root: {
    height: "600px",
  },
  div: {
    height: 450,
    margin: theme.spacing(3),
    overflow: "auto",
  },
  textCapitalize: {
    textTransform: "capitalize",
  },
  buttonsWafers: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    marginRight: "20px",
  },
  content: {
    display: "block",
    width: "95%",
    marginLeft: "20px"
  },
  button: {
    marginTop: "10px",
    marginLeft: "86%"
  },
}))

export default useStyles
